export const alimtalkLegend = [
  { id: 1, value: -1, titleKo: "개화전", color: "#E0E0E0" },
  { id: 2, value: 0, titleKo: "1차 발송 진행중", color: "#22C55E" }, // 초록
  { id: 3, value: 1, titleKo: "2차 발송 진행중", color: "#3B82F6" }, // 파랑
  { id: 4, value: 2, titleKo: "3차 발송 진행중", color: "#A855F7" }, // 보라
  { id: 5, value: 3, titleKo: "4차 발송 진행중", color: "#F59E0B" }, // 주황
  { id: 6, value: 4, titleKo: "5차 발송 진행중", color: "#EF4444" }, // 빨강
  { id: 7, value: 5, titleKo: "6차 발송 진행중", color: "#7F1D1D" }, // 진빨강
  { id: 8, value: 99, titleKo: "종료", color: "#9CA3AF" } // 회색
];

export const legendMap = Object.fromEntries(
    alimtalkLegend.map(item => [item.value, item])
);